import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "intro_box container"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "intro_left_title"
}, "企业概况", -1);

var _hoisted_3 = {
  class: "col-lg-12 col-md-12 col-sm-12"
};
var _hoisted_4 = {
  class: "hiden_box_intro"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: _normalizeClass(['intro_title_text', !$setup.showMore ? 'intro_title_text_show' : 'intro_title_none']),
        innerHTML: $setup.companyInfo.companyIntroduction
      }, null, 10, _hoisted_5)]), _createVNode(_component_el_collapse_item, {
        class: "article_collapse",
        name: 1
      }, {
        title: _withCtx(function () {
          return [];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_createElementVNode("div", {
            class: "intro_content_text",
            innerHTML: $setup.companyInfo.companyIntroduction
          }, null, 8, _hoisted_6)]), _createElementVNode("div", {
            class: "intro_more intro_close",
            onClick: _cache[0] || (_cache[0] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          })];
        }),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(['intro_more', 'intro_more_top', !$setup.showMore ? 'pany_opacity_show' : 'pany_opacity_none']),
        onClick: _cache[1] || (_cache[1] = function () {
          return $setup.toggleMore && $setup.toggleMore.apply($setup, arguments);
        })
      }, null, 2)])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}